import {
  takeLatest, put, call, select,
} from 'redux-saga/effects';
import { message } from 'antd';
import { autoRequest } from '@api/createRequestStore';
import { updateConfigData } from '@api/errorConfig';
import { fetchData } from '../configData/actions';
import * as actions from './actions';
import * as types from './types';
import { configCreatePayloadSeletor } from './selectors';

const updateMessages = {
  Enable: 'Error Logic Configuration has been enabled',
  Disable: 'Error Logic Configuration has been disabled',
  Delete: 'Error Logic Configuration has been deleted',
  Edit: 'Error Logic Configuration has been modified',
};

function* initRequest() {
  yield put(actions.init());
}

function* updateConfig(action) {
  const payload = { configuration: {} };
  Object.assign(payload.configuration, action.payload);
  try {
    yield autoRequest(updateConfigData, types.SCOPE, payload);
    const displayText = updateMessages[action.changeType || 'Edit'];
    yield put(actions.clearConfigForm());
    yield put(fetchData());
    yield call(message.success, displayText);
  } catch (error) {
    message.error(error.message || 'Unknown error!');
  }
}

function* createNewConfig() {
  const payload = yield select(configCreatePayloadSeletor);
  try {
    yield autoRequest(updateConfigData, types.SCOPE, payload);
    yield put(fetchData());
    yield call(message.success, 'Error Logic Configuration has been saved');
  } catch (error) {
    message.error(error.message || 'Unknown error!');
  }
}

function* watchInitRequest() {
  yield takeLatest([
    types.INIT,
  ], initRequest);
}

function* watchUpdateConfig() {
  yield takeLatest([
    types.UPDATE_CONFIG,
  ], updateConfig);
}

function* watchCreateConfig() {
  yield takeLatest([
    types.CREATE_CONFIG,
  ], createNewConfig);
}

export default [watchInitRequest,
  watchUpdateConfig,
  watchCreateConfig];
